import { reduce } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { connect, shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoUserHabilitation from '../../user/dto/DtoUserHabilitation'
import { PANEL_JOURNAL, PANEL_REQ } from '../constants/SuperAdminConstants'
import SuperAdminReqPanel from './SuperAdminReqPanel'
import SuperAdminJournalPanel from './SuperAdminJournalPanel'
import { Card, CardContent, Grid, Tab, Tabs } from '@mui/material'
import useTitle from 'utils/customHook/useTitle'

const SuperAdminPanel = () => {
    const [view, setView] = useState(PANEL_REQ)

    const userHabilitations = useSelector(store => store.UserReducer.userHabilitations, shallowEqual)

    useTitle(() => [{
        title: ' (̿▀̿‿ ̿▀̿ ̿)    Super Admin    (づ｡◕‿‿◕｡)づ',
        href: 'pgsse/dashboard',
    }], [])

    const listOfHabilitations = useMemo(() => {
        const result = reduce(
            userHabilitations,
            (a, b) => {
                (a[b.habilitation.split('_')[0]] || (a[b.habilitation.split('_')[0]] = [])).push(b)
                return a
            },
            {},
        )
        return Object.keys(result).map((o) => {
            return {
                module: o,
                values: result[o],
            }
        })
    }, [userHabilitations])

    return (
        <Grid style={{ padding: '0.75rem' }}>
            <Tabs
                value={view}
                onChange={(e, newValue) => setView(newValue)}
                variant='fullWidth'
            >
                <Tab value={PANEL_REQ} label={i18n.request}/>
                <Tab value={PANEL_JOURNAL} label={i18n.journal}/>
            </Tabs>
            <Card sx={{ borderRadius: '0 0 10px 10px' }}>
                <CardContent>
                    {view === PANEL_REQ && <SuperAdminReqPanel listOfHabilitations={listOfHabilitations} />}
                    {view === PANEL_JOURNAL && <SuperAdminJournalPanel listOfHabilitations={listOfHabilitations} />}
                </CardContent>
            </Card>
        </Grid>
    )
}

SuperAdminPanel.propTypes = {
    userHabilitations: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserHabilitation)),
}

const mapStateToProps = (store) => {
    return {
        userHabilitations: store.UserReducer.userHabilitations,
    }
}
export default connect(mapStateToProps)(SuperAdminPanel)

